<template>
    <div class>
        <div class="page-cnt">
            <!-- Left sidebar -->
            <div class="left-sidebar ex-has-btm">
                <SearchTour
                    :groupType="groupType"
                    :listVouchers="listVouchers"
                    :setErrorMessage="setErrorMessage"
                    :updateTourInfo="updateTourInfo"
                    @closedTour="closedTour"
                    v-if="renderSearchTour && !nonTravelGroupTypeId"
                    ref="childSearchTour"
                >
                    <BizPrePaidCard
                        v-model="selectedBizPrePaidCard"
                        :showUseBizPrePaidCard="showUseBizPrePaidCard"
                    />
                </SearchTour>

                <div class="content-wallet mt-4">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" v-if="groupType == constants.GroupVoucherType.cash_detail">
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                :class="{'active': screenType == constants.CashScreenType}"
                                @click="switchScreen(cashId, currencyId, constants.CashScreenType)"
                            >
                                <i class="icon-wallet mr-2"></i>
                                {{$t('cash.list_carry')}}
                                <span class="hidden-lap">{{$t('cash.balance_payments')}}</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                :class="{'active': screenType == constants.LocalIncomeScreenType}"
                                @click="switchScreen(cashId, currencyId, constants.LocalIncomeScreenType)"
                            >
                                <i class="icon-file mr-2"></i>
                                {{$t('cash.local_income')}}
                            </a>
                        </li>
                        <li v-if="tourInfo.tour_type==foreignType" class="nav-item">
                            <a
                                class="nav-link"
                                :class="{'active': screenType == constants.ExchangeScreenType}"
                                @click="switchScreen(cashId, currencyId, constants.ExchangeScreenType)"
                            >
                                <i class="icon-yen mr-2"></i>
                                {{$t('cash.exchange')}}
                            </a>
                        </li>
                    </ul>

                    <!-- Tab panes -->
                    <div class="tab-content">
                        <div id="balance" class="tab-pane active">
                            <cash-summary
                                v-if="cashDetails.cash_currency && screenType == constants.CashScreenType"
                                :cashDetails="cashDetails"
                                :onChangeCashDetails="onChangeCashDetails"
                                :slickOptions="slickOptions"
                                :useBizPrePaidCard="useBizPrePaidCard"
                                ></cash-summary>
                            <income-summary ref="income_summary"
                                v-else-if="cashDetails.cash_currency && isShowIncomeSummary && screenType == constants.LocalIncomeScreenType"
                                :summarys="summarys" :tourInfo="tourInfo" :slickOptions="summarySlickOptions"></income-summary>
                            <exchange-summary ref="exchange_summary"
                                v-else-if="cashDetails.cash_currency && isShowExchangeSummary && screenType == constants.ExchangeScreenType"
                                :summarys="summarys" :slickOptions="summarySlickOptions"></exchange-summary>

                            <!-- パンくずリスト -->
                            <div class="heading-breadcrumb">{{ getBreadCrumb() }}</div>

                            <!-- タブ -->
                            <ul class="nav nav-tabs" v-if="!nonTravelGroupTypeId">
                                <li
                                    v-for="tab in voucherTabs"
                                    :key="tab.voucherTypeId"
                                    class="nav-item"
                                >
                                    <a
                                        class="nav-link"
                                        :class="{
                                            active: activeVoucherTab == tab.voucherTypeId,
                                            disabled: !tab.canBeActive
                                        }"
                                        @click="tab.canBeActive && (activeVoucherTab = tab.voucherTypeId)"
                                    >
                                        {{ tab.name }}
                                    </a>
                                </li>
                            </ul>

                            <!-- 証憑一覧 -->
                            <div v-if="voucherLists[activeVoucherTab]" class="table-static">
                                <div v-for="(voucherList, groupMonth, index) in voucherLists[activeVoucherTab]" :key="index">
                                    <!-- 年度見出し（旅行勘定・未渡団体以外のみ） -->
                                    <div class="nta-fiscal-year" v-if="fiscalYearLabels[groupMonth]">{{ fiscalYearLabels[groupMonth] }}</div>
                                    <div class="table-heading mt-10">{{ dateUtils.formatDateYYYYMM(groupMonth) }}</div>
                                    <div class="table-cnt">
                                        <ul class="lst-static">
                                            <li
                                                v-for="voucher in voucherList"
                                                :key="voucher.id"
                                                :class="{'ex-highlight-row': activeVoucher == voucher.id}"
                                                @click="e => { if (activeVoucher != voucher.id) voucherDetails(voucher.id); }"
                                            >
                                                <voucher-row
                                                    :screenType="screenType"
                                                    :voucher="voucher"
                                                    :isExchange="screenType == constants.ExchangeScreenType"
                                                >
                                                </voucher-row>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="btns-btm" v-if="groupType != constants.GroupVoucherType.cash_detail">
                    <div class="d-flex justify-content-between align-items-center pl-3 pr-3">
                        <div class="row no-gutters w-100">
                            <div class="col-12 pl-1 pr-1">
                                <button
                                    class="btn btn-pink-44 w-100 ex-orange-light"
                                    data-toggle="modal"
                                    @click="addVoucherFromTab"
                                >
                                    <i class="icon-camera mr-2"></i>
                                    {{ $t('voucher.button.add_details') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="btns-btm" v-if="screenType == constants.ExchangeScreenType">
                    <div class="d-flex justify-content-between align-items-center pl-3 pr-3">
                        <div class="row no-gutters w-100">
                            <div class="col-6 pl-1 pr-1">
                                <button
                                    class="btn btn-pink-44 w-100 ex-orange-light"
                                    data-toggle="modal"
                                    @click="addVoucherCamera"
                                >
                                    <i class="icon-camera mr-2"></i>
                                    {{$t('voucher.button.add_details')}}
                                </button>
                            </div>
                            <div class="col-6 pr-1 pl-1">
                                <button
                                    class="btn btn-pink-44 w-100 ex-orange"
                                    data-toggle="modal"
                                    @click="addVoucherManual"
                                >
                                    <i class="icon-pen mr-2"></i>
                                    {{$t('voucher.button.manual_input')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="btns-btm" v-if="screenType == constants.CashScreenType || screenType == constants.LocalIncomeScreenType">
                    <div class="d-flex justify-content-between align-items-center pl-3 pr-3">
                        <div class="row no-gutters w-100">
                            <div class="col-4 pl-1 pr-1">
                                <button
                                    class="btn btn-pink-44 w-100 ex-orange-light"
                                    data-toggle="modal"
                                    @click="addVoucherCamera"
                                >
                                    <i class="icon-camera mr-2"></i>
                                    {{$t('voucher.button.add_details')}}
                                </button>
                            </div>
                            <div class="col-4 pr-1 pl-1">
                                <button
                                    class="btn btn-pink-44 w-100 ex-orange"
                                    data-toggle="modal"
                                    @click="addVoucherManual"
                                >
                                    <i class="icon-pen mr-2"></i>
                                    {{$t('voucher.button.manual_input')}}
                                </button>
                            </div>
                            <div class="col-4 pl-1 pr-1">
                                <button
                                    class="btn btn-pink-44 w-100 ex-border"
                                    @click="onClickOfficialRegisterBtn"
                                >
                                    <i class="icon-upload mr-2"></i>
                                    {{$t(utils.isCooperator() ? 'voucher.button.preview' : 'voucher.button.official_registration')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /Left sidebar -->

            <!-- Main content -->
            <div class="main-cnt">
                <div class="content-white">
                    <TourInfo v-if="!nonTravelGroupTypeId" :setErrorMessage="setErrorMessage" :tourInfoProp="tourInfo"></TourInfo>
                    <div class="error-message-voucher" v-if="errorMessage">
                        <div class="d-flex">
                            <i class="icon-warning mr-2"></i>
                            <div class="errror-txt">
                                <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                                <p class="fs-14 text-red font600">{{ errorMessage }}</p>
                            </div>
                        </div>
                        <a v-show="isNotTour" @click="setIsClosed" href="#" style="float:right;">締切済ツアーも対象として再検索</a>
                    </div>

                    <!-- Voucher details -->
                    <div class="content-body" v-if="modeDetails">
                        <div class="d-flex">
                            <button
                                class="btn btn-pink-53 w140 mr-3"
                                :disabled="!buttonEnabled"
                                @click="buttonEnabled && editVoucher()">
                                <i class="icon-edit-w mr-2"></i>
                                {{$t('button.edit')}}
                            </button>
                            <button
                                class="btn btn-gray-53 w140"
                                data-toggle="modal"
                                data-target="#modalDelete"
                                :disabled="utils.isReadOnly() || !canDelete(voucher.voucher_type_id, voucher)">
                                    <i class="icon-trash mr-2"></i>
                                    {{$t('button.delete')}}
                            </button>
                        </div>
                        <component
                            v-bind:is="componentDetailsVoucher"
                            :voucher="voucher"
                            @select-update-files="selectUpdateFiles"
                        ></component>
                    </div>

                    <!-- Add Voucher -->
                    <div class="content-body" v-if="modeAdd">
                        <component
                            v-bind:is="componentAddVoucher"
                            :setErrorMessage="setErrorMessage"
                            :voucherParams="voucherParams"
                            @voucherSuccess="voucherSuccess"
                            @cancelAdd="reset"
                            @showPreInputCopyModal="showPreInputCopyModal"
                            ref="addComponent"
                        ></component>
                    </div>

                    <!-- Edit voucher -->
                    <div class="content-body" v-if="modeEdit">
                        <component
                            v-bind:is="componentEditVoucher"
                            :setErrorMessage="setErrorMessage"
                            :voucherParams="voucherParams"
                            @voucherSuccess="voucherSuccess"
                            @cancelAdd="reset"
                        ></component>
                    </div>

                    <!-- Preview List files upload -->
                    <div class="content-body" v-if="previewFileUpload">
                        <preview-file-upload
                            :selectFiles="selectFiles"
                            :modeAddVoucher="isAddVoucher"
                            :cancelUpload="reset"
                            :uploadFiles.sync="uploadFiles"
                            :showThumb="showThumb"
                            :setErrorMessage="setErrorMessage"
                            :voucherType="voucherType"
                            :key="num"
                        ></preview-file-upload>
                    </div>
                </div>
            </div>
            <!-- /Main content -->
        </div>

        <DeleteVoucher
            :id="voucher.id"
            :getCashDetails="getCashDetails"
            :listVouchers="listVouchers"
            :groupType="groupType"
            :setErrorMessage="setErrorMessage"
            :reset="reset"
        ></DeleteVoucher>

        <SelectVoucherTypeModal
            :setVoucherType="setVoucherType"
            :screenType="screenType"
            :groupType="groupType"
            :selectFiles="selectFiles"
            :tourInfo="tourInfo"
            :useBizPrePaidCard="useBizPrePaidCard"
            ref="selectVoucherModal"
        ></SelectVoucherTypeModal>

        <!-- Modal show thumb file -->
        <show-img :setListFiles="setListFiles" :file="file"></show-img>

        <!-- The Modal Upload files -->
        <upload-file-modal
            :modalId="'uploadFileModal'"
            :previewFiles="previewFiles"
            :setListFiles="setListFiles"
            :uploadFiles="uploadFiles"
            :beforeCnt="beforeCnt"
        ></upload-file-modal>

        <!-- The Modal Update files -->
        <upload-file-modal
            :modalId="'updateFileModal'"
            :afterCheckPwdPdf="updateFiles"
            :previewFiles="previewFiles"
            :setListFiles="setListFiles"
            :uploadFiles="uploadFiles"
            :beforeCnt="beforeCnt"
        ></upload-file-modal>

        <pre-input-copy
            @setVoucher="setVoucher"
            ref="preInputCopy"
        ></pre-input-copy>

        <!-- The Modal Confirm to export excel -->
        <confirm-register-modal
            :summarys="summarys"
            :summarySlickOptions="summarySlickOptions"
            :tourInfo="utils.isCooperator() ? tourInfo : editTourInfo"
            @downloadExcel="downloadExcel"
            @exportExcel="exportExcel"
            @backEditTourInfo="backEditTourInfo"
            @onClickCancel="onClickCancel"
            ref="confirmRegister"
        >
        </confirm-register-modal>

        <edit-tour-info-modal
            @confirmRegister="nextOfficialRegistration"
            ref="editTour"
        >
        </edit-tour-info-modal>

        <!-- The Modal export excel success-->
        <b-modal
            id="successRegister"
            modal-class="modal fade modal-upload"
            hide-header hide-footer
            @hidden="exportExcelSuccess"
        >
            <button type="button" class="close" @click="$bvModal.hide('successRegister')">&times;</button>

            <div class="center-modal">
                <div class="center-ttl font300 d-flex justify-content-center">
                    <i class="icon-upload-orange mr-2"></i>
                    <span class="font500 text-pink">{{ msgExportExcel }}</span>
                </div>

                <div class="mt-4 text-center">
                    <i :class="isExportExcelSuccess ? 'icon-checked-circle' : 'icon-failed-circle'"></i>
                </div>
            </div>
        </b-modal>
        <b-modal class="modal fade modal-upload" id="errorDownloadExcel" hide-header hide-footer>
            <button type="button" class="close" @click="$bvModal.hide('errorDownloadExcel')">&times;</button>

            <div class="center-modal">
                <div class="center-ttl font300 d-flex justify-content-center">
                    <i class="icon-error-preview mr-2"></i>
                    <span class="font500 text-pink">{{ msgErrorDownloadExcel }}</span>
                </div>
            </div>
        </b-modal>

        <!-- The Modal confirm no payment register-->
        <b-modal class="modal fade" id="confirmNoPaymentRegister" v-model="isConfirmNoPaymentRegisterModalActive" centered hide-header hide-footer no-close-on-backdrop no-close-on-esc>
            <button v-if="!isCancelConfirm" type="button" class="close" @click="$bvModal.hide('confirmNoPaymentRegister')">&times;</button>
            <button v-else type="button" class="close" @click="showConfirmRegsiter(); $bvModal.hide('confirmNoPaymentRegister')">&times;</button>
            <div class="center-modal">
                <div class="center-ttl font300 d-flex justify-content-center" v-if="!isCancelConfirm">
                    {{ $t('voucher.modal-confirmNoPaymentRegister.message_no_data') }} <br/>
                    {{ utils.isCooperator() ? $t('voucher.modal-confirmNoPaymentRegister.message_preview') : $t('voucher.modal-confirmNoPaymentRegister.message_confirm') }}
                </div>
                <div class="center-ttl" style="text-align:center" v-else>
                    <div class=" font500">
                        本登録作業を中止しますか？
                    </div>
                    <p style="font-size: 13px; font-weight:300">
                        団体情報修正内容は破棄されますのでご注意ください。<br>
                        確認画面に戻る場合は、この画面を×で閉じてください
                    </p>
                </div>
                <div class="d-flex justify-content-center">
                    <div class="pr-2 w-165" v-if="!isCancelConfirm">
                        <button class="btn btn-pink-53 w-100" type="button" @click="onClickNoPaymentRegister">
                            {{ $t('button.ok') }}
                        </button>
                    </div>
                    <div class="pr-2 w-165" v-else>
                        <button class="btn btn-pink-53 w-100" type="button" @click="onClickNoPaymentRegister">
                            {{ $t('button.cancelRegister') }}
                        </button>
                    </div>
                    <div class="pl-2 w-165" v-if="!isCancelConfirm">
                        <button class="btn btn-gray-53 w-100" type="button" @click="$bvModal.hide('confirmNoPaymentRegister')">
                            {{ $t('button.cancel') }}
                        </button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
/* global $ */
import moment from 'moment';
import _ from 'lodash';
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';
import fileReader from "@/helpers/fileReader";
import { Constants } from "@/helpers/constants";

import StorageService from "@/services/common/storage.service";
import VoucherService from "@/services/module/voucher.service";
import CashService from "@/services/module/cash.service";
import { AuthService } from '@/services/common/auth.service';

import TourInfo from "@/views/layout/pc/Tour/Info";
import SearchTour from "@/views/layout/pc/Tour/Search";
import DeleteVoucher from "@/views/components/pc/Voucher/DeleteVoucher";
import SelectVoucherTypeModal from "@/views/components/pc/Voucher/SelectVoucherTypeModal";
import PreviewFileUpload from "@/views/components/pc/Voucher/PreviewFileUpload";
import UploadFileModal from "@/views/components/pc/Voucher/UploadFileModal";
import PreInputCopy from "@/views/components/pc/Voucher/PreInputCopy";
import ShowImg from "@/views/components/pc/Voucher/ShowImg";
import ConfirmRegisterModal from "@/views/components/pc/Voucher/ConfirmRegisterModal";
import EditTourInfoModal from "@/views/components/pc/Voucher/EditTourInfoModal";
import VoucherRow from '@/views/components/common/VoucherRow';
import CashSummary from "@/views/components/common/Summary/CashSummary";
import IncomeSummary from "@/views/components/common/Summary/IncomeSummary";
import ExchangeSummary from "@/views/components/common/Summary/ExchangeSummary";
import BizPrePaidCard from "@/views/components/pc/Voucher/BizPrePaidCard";

export default {
    components: {
        Slick,
        TourInfo,
        SearchTour,
        DeleteVoucher,
        SelectVoucherTypeModal,
        PreviewFileUpload,
        UploadFileModal,
        PreInputCopy,
        ShowImg: ShowImg,
        ConfirmRegisterModal,
        EditTourInfoModal,
        VoucherRow,
        CashSummary,
        IncomeSummary,
        ExchangeSummary,
        BizPrePaidCard
    },
    name: "PcListVoucher",
    data () {
        return {
            slickOptions: {
                dots: false,
                arrows: true,
                mobileFirst: true,
                infinite: false,
                slidesToShow: 1,
                centerMode: true,
                initialSlide: 0,
                variableWidth: true,
            },
            utils: Utils,
            dateUtils: DateUtils,
            constants: Constants,
            cashId: "",
            cash_id: "",
            tour_id: "",
            currencyId: "",
            cashDetails: [],
            listVoucher: [],
            voucherLists: {
                0: {},
                1: {},
                2: {},
            },
            activeVoucherTab: null,
            voucherId: "",
            cashDmosId: "",
            screenType: "",
            activeVoucher: "",
            errorMessage: "",
            voucher: {},
            groupType: "",
            voucherType: "",
            modeDetails: false,
            modeAdd: false,
            modeEdit: false,
            voucherParams: {
                voucherTypeId: "",
                cashInOutType: "",
                cashId: "",
            },
            uploadFiles: [],
            file: "",
            previewFileUpload: false,
            ocrData: {},
            num: 0,
            msgExportExcel: "",
            isExportExcelSuccess: false,
            msgErrorDownloadExcel: "",
            foreignType: Constants.TourType.international.id,
            tourInfo: {},
            isSaveSuccess: false,
            textTour: "",
            renderSearchTour: true,
            summarys: [],
            summarySlickOptions: {
                dots: false,
                arrows: true,
                mobileFirst: true,
                infinite: false,
                slidesToShow: 1,
                centerMode: true,
                initialSlide: 0,
                variableWidth: true,
            },
            isShowIncomeSummary: false,
            isShowExchangeSummary: false,
            group_id: "",
            filePath: "",
            signature: false,
            isConfirmNoPaymentRegisterModalActive: false,
            editTourInfo: {},
            isCancelConfirm: false,
            isNotTour: false,
            closeTour: "",
            selectedBizPrePaidCard: Constants.bizPrePaidCard[1],

            buttonEnabled: true,
            beforeCnt: 0,
        };
    },
    computed: {
        componentDetailsVoucher: {
            get: function () {
                if (this.modeDetails) {
                    let templateId = Utils.getTemplateId(
                        this.voucher.voucher_type_id
                    );
                    if (!Utils.isEmptyStr(templateId)) {
                        return () =>
                            import(
                                `../Voucher/Details/Temp_` + templateId + `.vue`
                            );
                    }
                }
                return null;
            },
            set: function (newValue) {
                this.modeDetails = newValue;
            },
        },
        componentAddVoucher: {
            get: function () {
                if (this.modeAdd) {
                    this.voucherParams = {};
                    let templateId = Utils.getTemplateId(this.voucherType);
                    if (!Utils.isEmptyStr(templateId)) {
                        if(this.screenType == Constants.CashScreenType) {
                            this.voucherParams.currencyId = this.currencyId;
                        }
                        this.voucherParams.voucherTypeId = this.voucherType;
                        this.voucherParams.cashInOutType = this.screenType;
                        this.voucherParams.cashId = this.cashId;
                        this.voucherParams.modeAdd = this.modeAdd;
                        let filePath = "";
                        if (this.ocrData.path) {
                            filePath = this.ocrData.path;
                        }
                        this.voucherParams.filePath = filePath;
                        let signature = false;
                        if (this.ocrData.signature) {
                            signature = this.ocrData.signature;
                        }
                        this.voucherParams.signature = signature;

                        // OCRの有無に関係なくグループ種別を保存
                        StorageService.saveGroupVoucherType(
                            JSON.stringify(this.groupType)
                        );

                        if (!Utils.isEmptyObj(this.ocrData.ocr) && !Utils.isEmptyObj(this.ocrData.ocr.mapping)) {
                            let data = this.ocrData.ocr.mapping
                                .template_mapping;
                            if (
                                data.transaction_date &&
                                data.transaction_date[0]
                            ) {
                                this.voucherParams.transactionDate = new Date(
                                    data.transaction_date[0]
                                );
                            }
                            if (data.use && data.use[0]) {
                                this.voucherParams.use = data.use[0];
                            }
                            if (data.account_name && data.account_name[0]) {
                                this.voucherParams.accountName =
                                    data.account_name[0];
                            }
                            if (data.personal && data.personal[0]) {
                                this.voucherParams.personal = data.personal[0];
                            }
                            if (data.unit_price && data.unit_price[0]) {
                                this.voucherParams.unitPrice =
                                    data.unit_price[0];
                            }
                            if (data.amount && data.amount[0]) {
                                if (templateId == Constants.VoucherType.receipt_local_placement_income.templateId) {
                                    let tourInfo = JSON.parse(StorageService.getTour());
                                    if (tourInfo.tour_type == Constants.TourType.domestic.id) {
                                        this.voucherParams.localPayment = data.amount[0];
                                    } else {
                                        this.voucherParams.localPaymentUnitPrice = data.amount[0];
                                        this.voucherParams.localPaymentPersonal = 1;
                                    }
                                } else {
                                    this.voucherParams.totalAmount = data.amount[0];
                                }
                            }
                            StorageService.saveGroupVoucherType(JSON.stringify(this.groupType));
                        }
                        return () =>
                            import(
                                `../Voucher/Add/Temp_` + templateId + `.vue`
                            );
                    }
                }
                return null;
            },
            set: function (newValue) {
                this.modeAdd = newValue;
            },
        },
        componentEditVoucher: {
            get: function () {
                if (this.modeEdit) {
                    let templateId = Utils.getTemplateId(
                        this.voucher.voucher_type_id
                    );

                    if (!Utils.isEmptyStr(templateId)) {
                        this.voucherParams = {};
                        this.voucherParams.id = this.voucher.id;
                        this.voucherParams.voucherNumber = this.voucher.voucher_number;
                        this.voucherParams.tourNumber = this.voucher.tour_number;
                        this.voucherParams.travelGroupName = this.voucher.travel_group_name;
                        this.voucherParams.cashId = this.voucher.cash_id;
                        this.voucherParams.docId = this.voucher.doc_id;
                        this.voucherParams.type = this.voucher.type;
                        this.voucherParams.voucherTypeId = this.voucher.voucher_type_id;
                        this.voucherParams.voucherTypeName = this.voucher.voucher_type_name;
                        this.voucherParams.transactionDate = new Date(
                            this.voucher.transaction_date
                        );
                        this.voucherParams.accountName = this.voucher.account_name;
                        this.voucherParams.exchangeRate = this.voucher.exchange_rate;
                        this.voucherParams.city = this.voucher.city;
                        this.voucherParams.use = this.voucher.use;
                        this.voucherParams.personal = this.voucher.personal;
                        this.voucherParams.service = this.voucher.service;
                        this.voucherParams.localIncomeUnitPrice = this.voucher.local_income_unit_price;
                        this.voucherParams.localIncomePersonal = this.voucher.local_income_personal;
                        this.voucherParams.localIncome = this.voucher.local_income;
                        this.voucherParams.localPaymentUnitPrice = this.voucher.local_payment_unit_price;
                        this.voucherParams.localPaymentPersonal = this.voucher.local_payment_personal;
                        this.voucherParams.localPayment = this.voucher.local_payment;
                        this.voucherParams.localUnpaidUnitPrice = this.voucher.local_unpaid_unit_price;
                        this.voucherParams.localUnpaidPersonal = this.voucher.local_unpaid_personal;
                        this.voucherParams.localUnpaid = this.voucher.local_unpaid;
                        this.voucherParams.income = this.voucher.income;
                        this.voucherParams.unitPrice = this.voucher.unit_price;
                        this.voucherParams.totalAmount = this.voucher.total_amount;
                        this.voucherParams.currencyId = this.voucher.currency_id;
                        this.voucherParams.cashInOutType = this.voucher.cash_in_out_type;
                        this.voucherParams.taxRate = this.voucher.tax_rate;
                        this.voucherParams.taxExempt = this.voucher.tax_exempt;
                        this.voucherParams.personInCharge = this.voucher.person_in_charge;
                        this.voucherParams.note = this.voucher.note;
                        this.voucherParams.exchangeType = this.voucher.exchange_type;
                        this.voucherParams.amountBeforeExchange = this.voucher.amount_before_exchange;
                        this.voucherParams.amountAfterExchange = this.voucher.amount_after_exchange;
                        this.voucherParams.currencyBeforeExchangeId = this.voucher.currency_before_exchange_id;
                        this.voucherParams.currencyAfterExchangeId = this.voucher.currency_after_exchange_id;
                        this.voucherParams.totalIncome = this.voucher.total_income;
                        this.voucherParams.totalExpenditure = this.voucher.total_expenditure;
                        this.voucherParams.totalBalance = this.voucher.total_balance;
                        this.voucherParams.targetFlag = this.voucher.target_flag;
                        this.voucherParams.billedFlag = this.voucher.billed_flag;
                        this.voucherParams.status = this.voucher.status;
                        this.voucherParams.currencyDisplayName = this.voucher.currency_display_name;
                        this.voucherParams.voucherName = this.voucher.voucher_name;
                        this.voucherParams.is_slip = this.voucher.is_slip;
                        this.voucherParams.postsend_flag = this.voucher.postsend_flag;
                        StorageService.saveGroupVoucherType(
                            JSON.stringify(this.groupType)
                        );

                        // Other taxrate
                        if (this.voucher.currency_id == Constants.JPY.id && this.voucher.tax_rate == Constants.VoucherTaxRate.Other.id && this.voucher.other_tax) {
                            let voucherOtherTax = [];
                            this.voucher.other_tax.forEach(function (item) {
                                let newItem = {};
                                newItem.id = item.id;
                                newItem.taxRate = item.tax_rate;
                                newItem.description = item.description;
                                newItem.price = item.price;
                                voucherOtherTax.push(newItem);
                            });
                            this.voucherParams.otherRate = voucherOtherTax;
                        } else {
                            this.voucherParams.otherRate = [];
                        }

                        return () =>
                            import(
                                `../Voucher/Add/Temp_` + templateId + `.vue`
                            );
                    }
                }
                return null;
            },
            set: function (newValue) {
                this.modeEdit = newValue;
            },
        },
        useBizPrePaidCard: function () {
            return this.showUseBizPrePaidCard && this.selectedBizPrePaidCard.id === 1;
        },
        showUseBizPrePaidCard: function () {
            return this.screenType == Constants.CashScreenType;
        },
        nonTravelGroupTypeId: function () {
            return !!this.groupType && this.groupType.id == Constants.GroupVoucherType.non_travel.id;
        },

        nonTravelVoucherTypeId: function () {
            const voucherTypeId = Number(this.$route.query.voucherType);
            return Utils.isVoucherTypeNonTravel(voucherTypeId) ? voucherTypeId : "";
        },
        // 年度見出し（年度が切り替わる最初の月にだけ表示する）
        fiscalYearLabels: function () {
            const labels = {};
            if (!this.nonTravelGroupTypeId || !this.listVoucher) {
                return labels;
            }
            const groupMonths = Object.keys(this.listVoucher);
            let prevFiscalYear = "";
            for (let i = 0; i < groupMonths.length; i++) {
                const fiscalYear = this.getFiscalYear(groupMonths[i]);
                if (fiscalYear !== "" && fiscalYear !== prevFiscalYear) {
                    labels[groupMonths[i]] = fiscalYear + this.$root.$t('general.fiscal_year');
                    prevFiscalYear = fiscalYear;
                }
            }
            return labels;
        },
        voucherTabs: function () {
            // 旅行勘定・未渡団体以外
            if (this.nonTravelGroupTypeId) {
                const voucherType = Utils.getVoucherType(this.nonTravelVoucherTypeId);

                if (voucherType) {
                    return [
                        {
                            voucherTypeId: voucherType.id,
                            name: voucherType.name,
                            canBeActive: false,
                        },
                    ];
                }
                return [];
            }

            if (this.groupType == Constants.GroupVoucherType.invoice_bill) {
                return [
                    {
                        voucherTypeId: Constants.VoucherType.invoice_bill.id,
                        name: Constants.VoucherType.invoice_bill.name,
                        canBeActive: true,
                    },
                    {
                        voucherTypeId: Constants.VoucherType.invoice_invoice.id,
                        name: Constants.VoucherType.invoice_invoice.name,
                        canBeActive: true,
                    },
                    {
                        voucherTypeId: Constants.VoucherType.invoice_bill_other.id,
                        name: Constants.VoucherType.invoice_bill_other.name,
                        canBeActive: true,
                    },
                ];
            }

            if (this.groupType == Constants.GroupVoucherType.local_expense_voucher) {
                let result = [
                    {
                        voucherTypeId: Constants.VoucherType.local_expense_voucher_carry_cash.id,
                        name: Constants.VoucherType.local_expense_voucher_carry_cash.name,
                        canBeActive: true,
                    },
                    {
                        voucherTypeId: Constants.VoucherType.local_expense_voucher_receipt.id,
                        name: Constants.VoucherType.local_expense_voucher_receipt.name,
                        canBeActive: true,
                    },
                    {
                        voucherTypeId: Constants.VoucherType.currency_exchange_receipt.id,
                        name: Constants.VoucherType.currency_exchange_receipt.name,
                        canBeActive: !this.tourInfo || !this.tourInfo.tour_number || this.tourInfo.tour_type == Constants.TourType.international.id,
                    },
                    {
                        voucherTypeId: Constants.VoucherType.local_expense_voucher_other.id,
                        name: Constants.VoucherType.local_expense_voucher_other.name,
                        canBeActive: true,
                    },
                ];

                if (this.tourInfo && this.tourInfo.tour_number && this.tourInfo.tour_type == Constants.TourType.domestic.id) {
                    result = [
                        {
                            voucherTypeId: Constants.VoucherType.local_expense_voucher_carry_cash.id,
                            name: Constants.VoucherType.local_expense_voucher_carry_cash.name,
                            canBeActive: true,
                        },
                        {
                            voucherTypeId: Constants.VoucherType.local_expense_voucher_receipt.id,
                            name: Constants.VoucherType.local_expense_voucher_receipt.name,
                            canBeActive: true,
                        },
                        {
                            voucherTypeId: Constants.VoucherType.local_expense_voucher_other.id,
                            name: Constants.VoucherType.local_expense_voucher_other.name,
                            canBeActive: true,
                        },
                    ]
                }

                return result;
            }

            return [];
        },
    },
    beforeMount () {
        // 旅行勘定・未渡団体以外はシステム管理者・管理者のみ
        if (this.$route.query.groupType == Constants.GroupVoucherType.non_travel.id && !Utils.isAdminAndSystemAdmin()) {
            this.$router.push("/tour/input");
            return;
        }
        this.tourInfo = JSON.parse(StorageService.getTour());
        if (this.$route.query.groupType) {
            this.groupType = this.getGroupVoucherTypeId(this.$route.query.groupType);
            this.activeVoucherTab = this.initActiveVoucherTab(this.groupType);
            this.listVouchers();
            this.getSummaryData();
        } else {
            this.activeVoucherTab = 0;
            this.groupType = Constants.GroupVoucherType.cash_detail;
            this.screenType = Constants.CashScreenType;
            this.getCashDetails();
        }
    },
    beforeUpdate () {},
    methods: {
        // 年度を返す
        getFiscalYear (date) {
            if (Utils.isEmptyStr(date)) {
                return "";
            };
            const target = moment(date, 'YYYY-MM');
            if (!target.isValid()) {
                return "";
            };
            const month = target.month() + 1;
            return month >= Constants.FiscalYearStartMonth ? target.year() : target.year() - 1;
        },
        setErrorMessage (msg) {
            this.errorMessage = msg;
        },
        initActiveVoucherTab (groupType) {
            if (groupType == Constants.GroupVoucherType.invoice_bill) {
                return Constants.VoucherType.invoice_bill.id;
            } else if (groupType == Constants.GroupVoucherType.local_expense_voucher) {
                return Constants.VoucherType.local_expense_voucher_carry_cash.id;
            } else if (groupType == Constants.GroupVoucherType.non_travel) {
                return this.nonTravelVoucherTypeId;
            }

            return null;
        },
        getGroupVoucherTypeId (groupVoucherTypeNum) {
            const groupVoucherType = Object.values(Constants.GroupVoucherType).find(
                voucherType => voucherType.id == groupVoucherTypeNum
            );
            return groupVoucherType || "";
        },
        canEdit (voucherTypeId, voucher) {
            if (Utils.isEmptyStr(voucherTypeId)) {
                return false;
            }
            return !(
                voucher.doc_id != null
                    &&
                voucher.doc_id !== ""
                    &&
                voucher.box_file_id == null
            );
        },
        getCashDetails (cashId = "", currencyId = "", screenType = "", voucherId = "") {
            this.cashDetails = [];
            this.cashDmosId = StorageService.getCashId();
            if (!this.cashDmosId) {
                let tourInfo = JSON.parse(StorageService.getTour());
                if (tourInfo && tourInfo.tour_number) {
                    this.$router.push(
                        "/tour/after-input?search=" + tourInfo.tour_number
                    );
                } else {
                    this.$router.push(
                        "/tour/input"
                    );
                }
            }
            return CashService.getCashDetail(
                this.cashDmosId,
                this.tourInfo.tour_number
            ).then(response => {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (response.status != 200) {
                    let errorCode = Utils.getErrorCode(response);
                    if (errorCode) {
                        let msg = this.$root.$t(
                            "error.error_code_" + errorCode
                        );
                        this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                    }
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        StorageService.saveCashIdServer(response.data.id);
                        this.cashDetails = response.data;

                        let currencies = this.cashDetails.cash_currency;

                        if (!Utils.isEmptyStr(currencyId)) {
                            this.currencyId = currencyId;
                        } else {
                            let obj = _.filter(currencies, {
                                currency_id: parseInt(this.currencyId),
                            });

                            if (Utils.isEmptyArr(obj)) {
                                this.currencyId = currencies[0].currency_id;
                            }
                        }

                        for (var i = 0; i < currencies.length; i++) {
                            if (currencies[i].currency_id == this.currencyId) {
                                this.slickOptions.initialSlide = i;
                            }
                        }

                        this.cashId = response.data.id;
                        this.listVouchers(cashId, currencyId, screenType, voucherId);
                        this.getSummaryData();
                    } else {
                        this.cashDetails = [];
                        let msg = this.$root.$t("general.no_data");
                        this.$toasted.success(msg, {});
                    }
                }
            });
        },
        getSummaryData () {
            this.summarys = [];
            if (Utils.isEmptyStr(this.screenType)) {
                return this.summarys;
            }
            return CashService.getSummary(this.cashId)
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    } else if (response.status != 200) {
                        let errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            let msg = this.$root.$t(
                                "error.error_code_" + errorCode
                            );
                            this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                        }
                    } else {
                        this.summarys = response.data;
                        this.isIncomesAndExchanges();
                        this.reInit();
                    }
                });
        },
        isIncomesAndExchanges () {
            this.isShowIncomeSummary = false;
            this.isShowExchangeSummary = false;
            for (let i = 0; i < this.summarys.length; i++) {
                const row = JSON.parse(JSON.stringify(this.summarys[i]));
                if (Object.keys(row.local_incomes).length) {
                    this.isShowIncomeSummary = true;
                }

                if (Object.keys(row.exchanges).length) {
                    this.isShowExchangeSummary = true;
                }
            }
        },
        reInit () {
            this.$refs.confirmRegister.$refs.slick_preChecks.destroy();
            this.$nextTick(() => {
                this.$refs.confirmRegister.$refs.slick_preChecks.create();
            });
            if (this.screenType == Constants.LocalIncomeScreenType && this.isShowIncomeSummary) {
                const slickIncom = this.$refs.income_summary.$refs.slick_incomes;
                if (typeof slickIncom != 'undefined') {
                    slickIncom.destroy();
                    this.$nextTick(() => {
                        slickIncom.create();
                    });
                }
            } else if (this.screenType == Constants.ExchangeScreenType && this.isShowExchangeSummary) {
                const slickExchange = this.$refs.exchange_summary.$refs.slick_exchanges;
                if (typeof slickExchange != 'undefined') {
                    slickExchange.destroy();
                    this.$nextTick(() => {
                        slickExchange.create();
                    });
                }
            }
        },
        onChangeCashDetails (event, slick, currentSlide) {
            if (currentSlide != this.slickOptions.initialSlide) {
                let currentCurrency = this.cashDetails.cash_currency[currentSlide];
                this.slickOptions.initialSlide = currentSlide;

                // get new data cash currency
                this.getCashCurrency(currentCurrency.id);

                // get new data list voucher
                this.listVouchers(
                    this.cashDetails.id,
                    currentCurrency.currency_id
                );
            }
        },
        listVouchers (cashId = "", currencyId = "", screenType = "", voucherId = "") {
            this.reset();
            if (cashId) {
                this.cashId = cashId;
            }
            if (currencyId) {
                this.currencyId = currencyId;
            }
            if (screenType) {
                this.screenType = screenType;
            }
            let request;
            
            // 旅行勘定・未渡団体以外はツアーに紐づかないため専用の取得処理
            if (this.nonTravelGroupTypeId) {
                request = VoucherService.getNonTravelList(
                    this.nonTravelVoucherTypeId
                );
            } else {
                request = VoucherService.list(
                    this.cashId,
                    this.currencyId,
                    this.screenType,
                    this.groupType.id,
                );
            }
            return request
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    } else if (response.status != 200) {
                        let errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            let msg = this.$root.$t(
                                "error.error_code_" + errorCode
                            );
                            this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                        }
                    } else {
                        if (!Utils.isEmptyObj(response.data)) {
                            this.listVoucher = response.data;
                            this.voucherLists = this.splitVoucherList(response.data);
                            if (this.isSaveSuccess) {
                            // this.voucherDetails(voucherId);
                            }
                        } else {
                            this.listVoucher = [];
                            this.voucherLists = {
                                0: {},
                                1: {},
                                2: {},
                            };
                            let msg = this.$root.$t("general.no_data");
                            this.$toasted.success(msg, {});
                        }
                    }
                })
                .catch(error => {
                    this.errorMessage = this.$root.$t("error.error_unknown");
                });
        },
        splitVoucherList (listVoucher) {
            // 携行現金収支明細
            if (this.groupType == Constants.GroupVoucherType.cash_detail) {
                return {
                    0: listVoucher,
                };
            }
            const result = {};

            this.voucherTabs.forEach((tab, _) => {
                result[tab.voucherTypeId] = {};
            });

            Object.keys(listVoucher).forEach(groupMonth => {
                listVoucher[groupMonth].forEach(voucher => {
                    const tabIndex = voucher.voucher_type_id;

                    if (!result[tabIndex][groupMonth]) {
                        result[tabIndex][groupMonth] = [];
                    }

                    result[tabIndex][groupMonth].push(voucher);
                });
            });

            return result;
        },
        getCashCurrency (cashCurrencyId = "") {
            CashService.getCashCurrency(
                cashCurrencyId
            ).then(response => {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (response.status != 200) {
                    let errorCode = Utils.getErrorCode(response);
                    if (errorCode) {
                        this.errorMessage = this.$root.$t(
                            "error.error_code_" + errorCode
                        );
                    }
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        for (var m = 0; m < this.cashDetails.cash_currency.length; m++) {
                            if (this.cashDetails.cash_currency[m].id == cashCurrencyId) {
                                this.cashDetails.cash_currency[m] = response.data;
                            }
                        }
                    }
                }
            });
        },
        switchScreen (cashId = "", currencyId = "", screenType = "") {
            this.selectedBizPrePaidCard = Constants.bizPrePaidCard[1];
            this.getCashDetails(cashId, currencyId, screenType);
        },
        voucherDetails (id) {
            this.voucher = [];
            this.isSaveSuccess = false;
            this.reset();
            this.activeVoucher = id;
            VoucherService.details(id).then(response => {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (response.status != 200) {
                    let errorCode = Utils.getErrorCode(response);
                    if (errorCode) {
                        this.setErrorMessage(
                            this.$root.$t("error.error_code_" + errorCode)
                        );
                    }
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        this.modeDetails = true;
                        this.component = this.modeDetails;
                        this.voucher = response.data;
                        let groupType = this.$route.query.groupType;

                        // SP 版の UI は enableButton というイベントを発行してハンドリングしているが、PC 版には仕組みがない
                        // そのためファイル内の data プロパティとして保持することにより機能実現を図る
                        this.buttonEnabled = this.canEdit(this.voucher.voucher_type_id, this.voucher)

                        if ((this.screenType == Constants.LocalIncomeScreenType && this.voucher.type == Constants.VoucherInOutType.Out.id) ||
                        (groupType == Constants.GroupVoucherType.local_expense_voucher.id && (this.voucher.service == Constants.VoucherService.Optional.id ||
                        this.voucher.service == Constants.VoucherService.Agreement.id || this.voucher.service == Constants.VoucherService.Gifts.id) && this.voucher.type == Constants.VoucherInOutType.Out.id)) {
                            this.voucher.total_amount = this.voucher.total_amount * -1;
                            this.voucher.income = this.voucher.income * -1;
                        }
                        this.voucherTypeId = this.voucher.voucher_type_id;
                        this.setErrorMessage("");
                    } else {
                        let msg = this.$root.$t("general.no_data");
                        this.$toasted.success(msg, {});
                    }
                }
            });
        },
        addVoucherManual () {
            this.reset();
            if (this.screenType == Constants.CashScreenType) {
                this.voucherType = Constants.VoucherType.no_voucher.id;
                this.modeAdd = true;
            }
            if (this.screenType == Constants.LocalIncomeScreenType) {
                this.voucherType =
                    Constants.VoucherType.local_placement_income_other_no_voucher.id;
                this.modeAdd = true;
            }
            if (this.screenType == Constants.ExchangeScreenType) {
                this.voucherType =
                    Constants.VoucherType.currency_exchange_receipt_cash.id;
                this.modeAdd = true;
            }
        },
        addVoucherCamera () {
            this.reset();
            if (this.screenType == Constants.CashScreenType) {
                $("#modalSelectVoucherType").modal("show");
                this.$refs.selectVoucherModal.selectType(Constants.VoucherType.receipt_carry_cash.id);
            } else if (this.screenType == Constants.LocalIncomeScreenType) {
                $("#modalSelectVoucherType").modal("show");
                this.$refs.selectVoucherModal.selectType(Constants.VoucherType.receipt_local_placement_income.id);
            } else if (this.screenType == Constants.ExchangeScreenType) {
                this.voucherType =
                    Constants.VoucherType.currency_exchange_receipt_cash.id;
                this.selectFiles();
            } else {
                if (this.nonTravelGroupTypeId) {
                    if (!this.nonTravelVoucherTypeId) {
                        return;
                    }
                    this.voucherType = this.nonTravelVoucherTypeId;
                    this.selectFiles();
                } else if (this.groupType == Constants.GroupVoucherType.other) {
                    this.voucherType =
                        Constants.VoucherType.certificate_Registration_other.id;
                    this.selectFiles();
                } else {
                    $("#modalSelectVoucherType").modal("show");
                    this.uploadFiles = [];
                }
            }
        },
        setVoucherType (type) {
            this.voucherType = type;
        },
        isAddVoucher (data = "") {
            this.previewFileUpload = false;
            this.modeAdd = true;
            this.ocrData = data;
        },
        editVoucher () {
            this.modeDetails = false;
            this.modeEdit = true;
        },
        canDelete (voucherTypeId, voucher) {
            if (Utils.isEmptyStr(voucherTypeId)) {
                return false;
            }
            return voucher.box_file_id != null && voucher.box_file_id !== "";
        },
        voucherSuccess (id, currencyId = "") {
            this.isSaveSuccess = true;
            if (this.groupType != Constants.GroupVoucherType.cash_detail) {
                this.listVouchers("", "", "", id).then(() => {
                    this.voucherDetails(id);
                });
            } else {
                this.updateTourInfo(JSON.parse(StorageService.getTour()));
                this.forceRerenderSearchTour();
                this.getCashDetails(StorageService.getCashIdServer(), currencyId, "", id).then(() => {
                    this.voucherDetails(id);
                });
            }
        },
        reset () {
            this.errorMessage = "";
            this.voucher = {};
            this.voucherId = "";
            this.voucherType = "";
            this.activeVoucher = "";
            this.uploadFiles = [];
            this.modeDetails = false;
            this.modeAdd = false;
            this.modeEdit = false;
            this.previewFileUpload = false;
            this.ocrData = {};
            this.group_id = "";
        },
        previewFiles () {
            this.modeAdd = false;
            this.modeEdit = false;
            $("#uploadFileModal").modal("hide");
            this.previewFileUpload = true;
            this.num += 1;
        },
        setListFiles (files) {
            this.uploadFiles = files;
        },
        showThumb (file) {
            this.file = file;
            $("#ShowImg").modal("show");
        },
        selectFiles () {
            this.beforeCnt = this.uploadFiles.length;
            $("#uploadFileModal").modal("show");
        },
        getBreadCrumb () {
            let groupType = this.$route.query.groupType;
            if (groupType == Constants.GroupVoucherType.invoice_bill.id) {
                return "証票登録 > 請求書・領収証(出金伝票・アト発行)";
            }
            if (groupType == Constants.GroupVoucherType.local_expense_voucher.id) {
                return "証票登録 > 現地経費関連証票";
            }
            if (groupType == Constants.GroupVoucherType.non_travel.id) {
                const voucherType = Utils.getVoucherType(this.nonTravelVoucherTypeId);
                return "旅行勘定・未渡団体以外" + (voucherType ? " > " + voucherType.name : "");
            }
        },
        downloadExcel () {
            this.msgErrorDownloadExcel = "";
            let tourNumber = this.editTourInfo['tour_number'];
            const developerName = StorageService.getDeveloperName();
            this.editTourInfo.developerName = developerName;
            // formatDateDefaultの変換時にv-modelに紐づけた日付が壊れるのでディープコピーする
            const param = _.cloneDeep(this.editTourInfo);
            param.departure_date = DateUtils.formatDateDefault(param.departure_date);
            param.return_date = DateUtils.formatDateDefault(param.return_date);
            CashService.downloadExcel(this.cashId, param)
                .then(async response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    } else if (response.status != 200) {
                        this.msgErrorDownloadExcel = this.$t('error.error_unknown');
                        let errorCode = false;
                        let resdata = await fileReader(response.data);
                        response.data = JSON.parse(resdata);
                        errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            this.msgErrorDownloadExcel = this.$t('error.error_code_' + errorCode);
                        }
                        this.$bvModal.show('errorDownloadExcel');
                    } else {
                        let link = document.createElement('a');
                        let reader = new FileReader();
                        reader.readAsDataURL(response.data);
                        reader.onload = function () {
                            link.href = reader.result;
                            link.download = "携行現金収支明細-" + tourNumber + ".xlsx";
                            link.click();
                        };
                    }
                })
                .catch(error => {
                    this.msgErrorDownloadExcel = this.$root.$t("error.error_unknown");
                    this.$bvModal.show('errorDownloadExcel');
                });
        },
        exportExcel () {
            this.isExportExcelSuccess = false;
            let keyName = StorageService.getCashKeyName();
            this.editTourInfo.keyName = keyName;
            const developerName = StorageService.getDeveloperName();
            this.editTourInfo.developerName = developerName;
            // formatDateDefaultの変換時にv-modelに紐づけた日付が壊れるのでディープコピーする
            const param = _.cloneDeep(this.editTourInfo);
            param.departure_date = DateUtils.formatDateDefault(param.departure_date);
            param.return_date = DateUtils.formatDateDefault(param.return_date);
            CashService.exportExcel(this.cashId, param)
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    } else if (response.status != 200) {
                        this.msgExportExcel = this.$t("error.error_unknown");
                        let errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            this.msgExportExcel = this.$t('error.error_code_' + errorCode);
                        }
                        this.$bvModal.show('successRegister');
                    } else {
                        let errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            this.isExportExcelSuccess = false;
                            this.msgExportExcel = this.$t('error.error_code_' + errorCode);
                        } else {
                            this.isExportExcelSuccess = true;
                            this.msgExportExcel = this.$t('voucher.message.registerSuccess');
                            StorageService.removeCashName();
                            StorageService.removeCashKeyName();
                        }

                        this.$bvModal.show('successRegister');
                    }
                })
                .catch(error => {
                    this.msgExportExcel = this.$root.$t("error.error_unknown");
                });
        },
        exportExcelSuccess () {
            if (this.isExportExcelSuccess) {
                StorageService.removeDeveloperName();
                let tourInfo = JSON.parse(StorageService.getTour());
                this.$router.push(
                    "/tour/after-input?search=" + tourInfo.tour_number
                );
            }
        },
        updateTourInfo (tour) {
            this.tourInfo = tour;
        },
        forceRerenderSearchTour () {
            this.renderSearchTour = false;
            this.$nextTick(() => {
                this.renderSearchTour = true;
            });
        },
        onStorageUpdate (event) {
            if (event.key === "cash_id") {
                this.cash_id = event.newValue;
                this.setErrorMessage(
                    this.$root.$t("error.error_old_data")
                );
            }
            if (event.key === "tour_id") {
                this.tour_id = event.newValue;
                this.setErrorMessage(
                    this.$root.$t("error.error_old_data")
                );
            }
        },
        setVoucher () {
            this.$refs.addComponent.setVoucher();
        },
        showPreInputCopyModal () {
            this.$refs.preInputCopy.setPreInputList();
            $("#preInputCopyModal").modal("show");
        },
        onClickOfficialRegisterBtn () {
            if (this.cashDetails.has_voucher == true) {
                this.$refs.editTour.init();
                Utils.isCooperator() ? $("#confirmRegister").modal("show") : $("#editTourInfo").modal("show");
            } else {
                this.isConfirmNoPaymentRegisterModalActive = true;
                this.isCancelConfirm = false;
            }
        },
        onClickNoPaymentRegister () {
            this.isConfirmNoPaymentRegisterModalActive = false;
            if (this.isCancelConfirm) {
                $("#confirmRegister").modal("hide");
                $("#editTourInfo").modal("hide");
            } else if (Utils.isCooperator()) {
                $("#confirmRegister").modal("show");            
            } else {
                this.$refs.editTour.init();
                $("#editTourInfo").modal("show");
            }
        },
        nextOfficialRegistration (editTourInfo) {
            this.$refs.confirmRegister.showTour = false;
            this.editTourInfo = editTourInfo;
            $("#editTourInfo").modal("hide");
            this.$nextTick(() => (this.$refs.confirmRegister.showTour = true));
            $("#confirmRegister").modal("show");
        },
        backEditTourInfo () {
            this.$refs.confirmRegister.showTour = false;
            $("#editTourInfo").modal("show");
        },
        onClickCancel () {
            this.$refs.confirmRegister.showTour = false;
            $("#confirmRegister").modal("hide");
            if(!Utils.isCooperator() && !Utils.isReadOnly()) {
                this.isCancelConfirm = true;
                this.isConfirmNoPaymentRegisterModalActive = true;
            }
        },
        showConfirmRegsiter () {
            this.$nextTick(() => (this.$refs.confirmRegister.showTour = true));
            $("#confirmRegister").modal("show");
        },
        setIsClosed () {
            this.$refs.childSearchTour.reSearchTour(this.closeTour);
        },
        closedTour (closeTour) {
            console.log("set close");
            this.isNotTour = true;
            this.closeTour = closeTour;
        },
        addVoucherFromTab () {
            this.reset();
            this.$refs.selectVoucherModal.selectType(this.activeVoucherTab);
            this.$refs.selectVoucherModal.addVoucher();
        },
        selectUpdateFiles () {
            this.beforeCnt = this.uploadFiles.length;
            $("#updateFileModal").modal("show");
        },
        async updateFiles (formD) {
            try {
                // アップロード対象ファイルを取得
                const files = formD.getAll("files");

                if (!files.length) {
                    this.$toasted.error(
                        this.$root.$t("error.error_unknown"),
                        {}
                    );
                    return;
                }

                // S3アップロード用FormDataを作成
                const uploadFormData = new FormData();

                files.forEach(file => {
                    uploadFormData.append("files", file);
                });

                const oldestDate = Math.min(
                    ...files.map(file => file.lastModified)
                );

                uploadFormData.append("oldest_date", oldestDate);
                uploadFormData.append("ocr", 0);
                uploadFormData.append(
                    "voucherType",
                    this.voucher.voucher_type_id
                );
                uploadFormData.append("handwriteOcr", 0);
                uploadFormData.append("imprintRemovalOcr", 0);

                // S3へファイルをアップロード
                const uploadResponse = await VoucherService.upload(
                    uploadFormData
                );

                // アップロード失敗時の処理
                if (!uploadResponse || uploadResponse.status !== 200) {
                    if (uploadResponse && uploadResponse.status === 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                        return;
                    }

                    const errorCode = uploadResponse
                        ? Utils.getErrorCode(uploadResponse)
                        : null;

                    const message = errorCode
                        ? this.$root.$t("error.error_code_" + errorCode)
                        : this.$root.$t("error.error_unknown");

                    this.$toasted.error(message, {});
                    return;
                }

                // S3のファイルパスを取得
                const filePath = uploadResponse.data
                    ? uploadResponse.data.path
                    : null;

                if (!filePath) {
                    this.$toasted.error(
                        this.$root.$t("error.error_unknown"),
                        {}
                    );
                    return;
                }

                // ファイル差し替えAPIを実行
                const path = require("path");

                const response = await VoucherService.updateFile(
                    this.voucher.id,
                    {
                        filePath: filePath,
                        extend: path.extname(filePath),
                        csrfToken: Utils.generateRandomString()
                    }
                );

                // 以下は既存のエラーハンドリング
                if (!response || response.status !== 200) {
                    if (response && response.status === 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                        return;
                    }

                    const errorCode = response
                        ? Utils.getErrorCode(response)
                        : null;

                    let message = this.$root.$t("error.error_unknown");

                    if (errorCode) {
                        message = this.$root.$t(
                            "error.error_code_" + errorCode
                        );
                    }

                    this.$toasted.error(message, {});
                    return;
                }

                const detailsLoaded =
                    await this.getVoucherDetails(this.voucher.id);

                if (!detailsLoaded) {
                    return;
                }

                $("#updateFileModal").modal("hide");

                let message = this.$root.$t("success.update_success");
                this.$toasted.success(message, {});

                this.uploadFiles = [];
                this.beforeCnt = 0;

            } catch (error) {
                this.$toasted.error(
                    this.$root.$t("error.error_unknown"),
                    {}
                );
            }
        },
        getVoucherDetails (voucherId) {
            return VoucherService.getVoucherDetails(voucherId).then(
                response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                        return false;
                    } else if (response.status != 200) {
                        let errorCode = Utils.getErrorCode(response);
                        let message = errorCode ?  this.$root.$t("error.error_code_" + errorCode) : this.$root.$t("error.error_unknown");
                        this.$toasted.error(message, {});
                        return false;
                    } else {
                        if (!Utils.isEmptyObj(response.data)) {
                            this.voucher = response.data;
                            this.history = response.data.history;

                            // TODO: necessary?
                            // if (!this.isContractVoucher(this.voucher.voucher_type_id)) {
                            this.buttonEnabled = this.canEdit(this.voucher.voucher_type_id, this.voucher)
                            // }
                            this.setErrorMessage("");

                            if ((this.screenType == Constants.LocalIncomeScreenType && this.voucher.type == Constants.VoucherInOutType.Out.id) ||
                            (this.voucher.voucher_type_id == Constants.VoucherType.local_expense_voucher_receipt.id && (this.voucher.service == Constants.VoucherService.Optional.id ||
                            this.voucher.service == Constants.VoucherService.Agreement.id || this.voucher.service == Constants.VoucherService.Gifts.id ) && this.voucher.type == Constants.VoucherInOutType.Out.id)) {
                                this.voucher.total_amount = this.voucher.total_amount * -1;
                                this.voucher.income = this.voucher.income * -1;
                            }
                            return true;
                        } else {
                            this.voucher = [];
                            let msg = this.$root.$t("general.no_data");
                            this.$toasted.success(msg, {});
                            return false;
                        }
                    }
                }
            ).catch(error => {
                this.setErrorMessage(
                    this.$root.$t("error.error_unknown")
                );
                return false;
            });
        },
    },
    mounted () {
        if (localStorage.cash_id) {
            this.cash_id = localStorage.cash_id;
        }
        if (localStorage.tour_id) {
            this.tour_id = localStorage.tour_id;
        }
        window.addEventListener("storage", this.onStorageUpdate);
    },
    beforeDestroy () {
        window.removeEventListener("storage", this.onStorageUpdate);
    },
    watch: {
        cash_id (newCashId) {
            localStorage.cash_id = newCashId;
        },
        tour_id (newTourId) {
            localStorage.tour_id = newTourId;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/pc/Voucher/List.vue